(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ancona-stud-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.sfWired) return;
    root.dataset.sfWired = '1';
    var chips = root.querySelector('.ancona-sf__chips');
    var status = root.querySelector('.ancona-sf__status');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-sf-row]'));
    if (!chips || !rows.length) return;
    var state = { c: 'all', cl: 'all', av: 'all' };
    var bands = Array.prototype.slice.call(root.querySelectorAll('details[data-sf-band]'));
    var clearBtn = root.querySelector('[data-sf-clear]');
    var mobileMq = window.matchMedia('(max-width: 749px)');
    chips.hidden = false;
    // Ancona Pass 25: F3 — desktop styles the band summaries as static headings
    // (cursor: default, no chevron), so make them genuinely inert there: tabIndex -1
    // keeps them out of the tab order and the capture click handler swallows the
    // toggle. Mobile restores the disclosure behavior, tracked live via the same
    // mobileMq. Remove this block to revert.
    var summaries = bands.map(function (b) { return b.querySelector('.ancona-sf__bandsummary'); }).filter(Boolean);
    function anyActive() { return state.c !== 'all' || state.cl !== 'all' || state.av !== 'all'; }
    function syncBandMode() {
      summaries.forEach(function (s) { s.tabIndex = mobileMq.matches ? 0 : -1; });
      bands.forEach(function (b) {
        if (!mobileMq.matches || (anyActive() && !b.hidden)) b.setAttribute('open', '');
        else b.removeAttribute('open');
      });
    }
    syncBandMode();
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', syncBandMode);
    else if (mobileMq.addListener) mobileMq.addListener(syncBandMode);
    root.addEventListener('click', function (e) {
      if (!mobileMq.matches && e.target.closest('.ancona-sf__bandsummary')) e.preventDefault();
    });
    if (status) status.textContent = rows.length + ' of ' + rows.length + ' studs shown';
    function apply() {
      var shown = 0;
      rows.forEach(function (r) {
        var ok = true;
        if (state.c !== 'all') {
          var parts = state.c.split('-'); var v = parseInt(r.dataset.c || '0', 10);
          ok = v >= parseInt(parts[0], 10) && v <= parseInt(parts[1], 10);
        }
        if (ok && state.cl !== 'all') ok = (r.dataset.cl === state.cl);
        if (ok && state.av !== 'all') ok = (r.dataset.av === state.av);
        r.hidden = !ok;
        if (ok) shown++;
      });
      root.querySelectorAll('[data-sf-band]').forEach(function (b) {
        var any = b.querySelector('[data-sf-row]:not([hidden])');
        b.hidden = !any;
      });
      // Mobile: filtering opens every band that still has matches, so results are visible
      // without extra taps; with no active filter the compact collapsed index returns.
      syncBandMode();
      if (clearBtn) clearBtn.hidden = !anyActive();
      if (status) status.textContent = shown + ' of ' + rows.length + ' studs shown';
    }
    chips.addEventListener('click', function (e) {
      var btn = e.target.closest('.ancona-sf__chip');
      if (!btn) return;
      var group = btn.parentElement;
      var key = btn.hasAttribute('data-sf-carat') ? 'c' : btn.hasAttribute('data-sf-clarity') ? 'cl' : 'av';
      var val = btn.getAttribute('data-sf-carat') || btn.getAttribute('data-sf-clarity') || btn.getAttribute('data-sf-avail');
      state[key] = val;
      group.querySelectorAll('.ancona-sf__chip').forEach(function (c) { c.setAttribute('aria-pressed', c === btn ? 'true' : 'false'); });
      apply();
    });
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        state.c = 'all'; state.cl = 'all'; state.av = 'all';
        chips.querySelectorAll('.ancona-sf__chip').forEach(function (c) {
          var isAll = c.getAttribute('data-sf-carat') === 'all' || c.getAttribute('data-sf-clarity') === 'all' || c.getAttribute('data-sf-avail') === 'all';
          c.setAttribute('aria-pressed', isAll ? 'true' : 'false');
        });
        apply();
      });
    }
  }
  function boot() { document.querySelectorAll('[data-ancona-sf]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const media = window.matchMedia('(max-width: 749px)');

    const setExpanded = (button, panel, expanded) => {
      button.setAttribute('aria-expanded', String(expanded));
      panel.hidden = !expanded;
    };

    const syncBlock = (block) => {
      const button = block.querySelector('.footer-block__toggle');
      const panel = block.querySelector('.footer-block__details-content');
      if (!button || !panel) return;

      if (media.matches) {
        const enteringMobile = !block.classList.contains('is-mobile-collapsible');
        block.classList.add('is-mobile-collapsible');
        button.hidden = false;
        if (enteringMobile) setExpanded(button, panel, false);
      } else {
        block.classList.remove('is-mobile-collapsible');
        button.hidden = true;
        setExpanded(button, panel, true);
      }

      if (button.dataset.footerToggleBound === 'true') return;
      button.dataset.footerToggleBound = 'true';

      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        setExpanded(button, panel, !expanded);
      });

      block.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || button.getAttribute('aria-expanded') !== 'true') return;
        setExpanded(button, panel, false);
        button.focus();
      });
    };

    const init = (root = document) => {
      root.querySelectorAll('.footer-block--menu').forEach(syncBlock);
    };

    init();
    media.addEventListener('change', () => init());
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
